import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "./app/AppLayout";
import { Collection } from "./app/pages/Collection";
import { Library } from "./app/pages/Library";
import { Play } from "./app/pages/Play";
import { Layout } from "./Layout";
import { Landing } from "./pages/Landing";
import { Privacy } from "./pages/Privacy";
import { Terms } from "./pages/Terms";
import { Tokushoho } from "./pages/Tokushoho";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Landing />} />
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="ja" element={<Landing />} />
        <Route path="ja/terms" element={<Terms />} />
        <Route path="ja/privacy" element={<Privacy />} />
        <Route path="ja/tokushoho" element={<Tokushoho />} />
      </Route>
      <Route path="/app" element={<AppLayout />}>
        <Route index element={<Library />} />
        <Route path="c/:slug" element={<Collection />} />
        <Route path="p/:id" element={<Play />} />
        <Route path="settings" element={<Navigate to="/app?account=1" replace />} />
      </Route>
    </Routes>
  </BrowserRouter>,
);
